import type { IntentRuleId } from '@ipfabric/utils';
import { loadGraph } from 'components/Graph/commands/loadGraph';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface CheckIntentCommand {
  intentRule: IntentRuleId | null;
}

export const checkIntent: GraphCommandFactory<CheckIntentCommand> =
  (_cmdContext, dispatch) => (command) =>
    dispatch(loadGraph, {
      overlay:
        command.intentRule !== null
          ? {
              type: 'intent',
              intentRuleId: command.intentRule,
            }
          : 'none',
    });
